import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  useTheme,
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { TooltipLabel, Loader, PaginationAction } from "components";
import { UPLOAD_FILES_HEADERS } from "pages/SupplyPanel/constant";
import DownloadIcon from "@mui/icons-material/Download";
import { formatDate, getStatusStyle } from "../DataModel";

const UploadFilesTable = ({
  data,
  isLoading,
  page,
  onPageChange,
  count,
  onDownload,
  rowsPerPage,
}) => {
  const theme = useTheme();

  return (
    <TableContainer
      component={Paper}
      sx={{ mt: 3, borderRadius: 2, maxHeight: 350, overflowY: "auto" }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {UPLOAD_FILES_HEADERS.map((column, i) => (
              <TableCell key={column} sx={{ width: i === 0 ? "40%" : "20%" }}>
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={UPLOAD_FILES_HEADERS.length}>
                <Loader sx={{ margin: 0 }} />
              </TableCell>
            </TableRow>
          ) : data?.length ? (
            data.map((file) => {
              const status = getStatusStyle(file?.fileStatus, theme);
              const isFailed = file?.fileStatus === "FAILED";

              return (
                <TableRow
                  key={file.fileId}
                  sx={{
                    "& td": {
                      backgroundColor: isFailed
                        ? theme.palette.error.errorBgColor
                        : "inherit",
                    },
                    "&:hover td": {
                      backgroundColor: isFailed
                        ? theme.palette.error.errorBgColor
                        : "inherit",
                    },
                  }}
                >
                  <TableCell>
                    <Typography>{file?.fileName}</Typography>
                  </TableCell>

                  <TableCell>{formatDate(file?.uploadDateTime)}</TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography sx={{ color: status.color }}>
                        {status.label}
                      </Typography>
                      {file?.fileProcessingError && (
                        <TooltipLabel
                          placement="bottom"
                          title={file.fileProcessingError}
                          labelChildren={
                            <InfoOutlined
                              sx={{ width: 16, marginTop: 4 }}
                              color="primary"
                            />
                          }
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {file?.failedRecordCount > 0 ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                          sx={{ minWidth: 80 }}
                        >{`${file.failedRecordCount} Errors`}</Typography>
                        <DownloadIcon
                          fontSize="small"
                          sx={{
                            cursor: "pointer",
                            flexShrink: 0,
                            color: theme.palette.primary.main,
                          }}
                          onClick={() => onDownload(file.fileId, file.fileName)}
                        />
                      </Box>
                    ) : (
                      <Typography>No error</Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={UPLOAD_FILES_HEADERS.length} align="center">
                No data found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {data?.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[rowsPerPage]}
          rowsPerPage={rowsPerPage}
          page={page}
          count={count}
          onPageChange={onPageChange}
          ActionsComponent={PaginationAction}
          sx={{ display: "flex", flexDirection: "column-reverse" }}
        />
      )}
    </TableContainer>
  );
};

export default UploadFilesTable;
